import { CodeTypeE, IProfile } from 'primsell-shared-layer/types'

export enum AccountOperationStatusesE {
  PENDING = 'pending',
  DECLINED = 'declined',
  PROCESSING = 'processing',
  COMPLETED = 'completed',
}

export enum CryptoCurrenciesE {
  MATIC = 'MATIC',
  WETH = 'WETH',
}

export enum FiatCurrenciesE {
  EUR = 'EUR',
  CAD = 'CAD',
}

export type AllCurrenciesT = CryptoCurrenciesE | FiatCurrenciesE

export interface IAccountBalanceByCurrency {
  cryptoAsset: CryptoCurrenciesE
  cryptoRoyaltyAmount: string
  fiatAsset: FiatCurrenciesE
  fiatRoyaltyAmount: string
}

export interface IGetAccountOperationsRequest {
  fromDate?: string
  toDate?: string
  status?: AccountOperationStatusesE
  limit: number
  offset: number
}

export interface IAccountOperation {
  id: string
  status: AccountOperationStatusesE
  amount: string
  currency: CryptoCurrenciesE
  fee: null | string
  tx: null | string
  wallet: string
  createdAt: string
  updatedAt: string
  meta: {
    buyerIdentityId: string
    buyerIdentityName: string
    buyerIdentityWallet: string
    campaignId: string
    campaignName: string
    campaignCodeType: CodeTypeE
  }
}

export interface ICreateWithdrawRequest {
  wallet: string
  currency: CryptoCurrenciesE
  amount?: number
}

export interface ICreateWithdrawResponse {
  id: string
  type: string
  accountId: IProfile['id']
  absAmount: string
  status: AccountOperationStatusesE
  amount: string
  wallet: string
  fee: null | string
  tx: null | string
  updatedAt: string
  createdAt: string
}
